var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "employee-detail" } },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important",
            height: "110px"
          }
        },
        [
          _vm.employee_detail
            ? _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("img", {
                        staticClass: "back-to-list-apps m__t--20",
                        attrs: { src: require("@/assets/icon/arrow-left.svg") },
                        on: {
                          click: function($event) {
                            _vm.$router.push("/administrator")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.employee_detail
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-between m--10"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "m__r--10" },
                                    [
                                      _vm.employee_detail.photo_url
                                        ? _c("b-img", {
                                            staticClass: "img-employee",
                                            attrs: {
                                              src:
                                                _vm.employee_detail.photo_url,
                                              rounded: "circle",
                                              alt: "img"
                                            }
                                          })
                                        : _c("b-img", {
                                            staticClass: "img-employee",
                                            attrs: {
                                              src: require("../../assets/logo/user1.png"),
                                              rounded: "circle",
                                              alt: "img"
                                            }
                                          })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "h6",
                                      {
                                        staticClass: "font-weight-bold m__b--0"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.employee_detail.first_name
                                            ) +
                                            " " +
                                            _vm._s(
                                              _vm.employee_detail.last_name
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.employee_detail.email) +
                                          " "
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c("i", {
                      staticClass:
                        "fa fa-ellipsis-v fa-lg cursor-pointer pull-right m__t--10",
                      attrs: { id: "configPopover" }
                    })
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex m__t--2" },
            _vm._l(_vm.tabOptions, function(tab) {
              return _c("div", { key: tab.id }, [
                tab.isShow
                  ? _c(
                      "div",
                      {
                        staticClass: "tab-experience-manager m__r--35",
                        class: {
                          "tab-experience-manager-active":
                            _vm.tabSelected === tab.id
                        },
                        on: {
                          click: function($event) {
                            _vm.tabSelected = tab.id
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(tab.title) + "\n        "
                        )
                      ]
                    )
                  : _vm._e()
              ])
            })
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.employee_detail
        ? _c(
            "b-popover",
            {
              ref: "configPopoverRef",
              attrs: {
                show: _vm.configPopoverShow,
                target: "configPopover",
                container: "employee-detail",
                placement: "left"
              },
              on: {
                "update:show": function($event) {
                  _vm.configPopoverShow = $event
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "user-config-opt",
                  on: { click: _vm.openModalchangePassword }
                },
                [_vm._v("\n      Change Password\n    ")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "user-config-opt",
                  on: { click: _vm.deletedEmployee }
                },
                [_vm._v("\n      Delete\n    ")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "changePasswordModal",
          staticClass: "mod-form modal-change-password",
          attrs: {
            centered: "",
            "no-close-on-backdrop": "",
            "no-close-on-esc": ""
          }
        },
        [
          _c(
            "h3",
            {
              staticClass: "modal-title",
              staticStyle: { color: "#9A9A9A !important" }
            },
            [_vm._v("\n      CHANGE PASSWORD\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-form",
            [
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input":
                      _vm.$v.form.password.$error || _vm.isNotStrenghtPassword
                  },
                  attrs: { id: "password-input" }
                },
                [
                  _c("label", [_vm._v(" Password ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "max-length": 50,
                      type: _vm.passwordType,
                      "error-required": _vm.$v.form.password.$error,
                      "error-message": "Field is required",
                      placeholder: "Type new password"
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "showhide" }, [
                    _c("i", {
                      class: {
                        "fa fa-eye": !_vm.showPassword,
                        "fa fa-eye-slash": _vm.showPassword,
                        "eye-error":
                          _vm.$v.form.password.$error ||
                          _vm.isNotStrenghtPassword
                      },
                      on: {
                        click: function($event) {
                          _vm.showPassword = !_vm.showPassword
                        }
                      }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("PasswordChecker", {
                ref: "passwordChecker",
                staticClass: "my-1",
                attrs: { data: _vm.passwordCheckerData }
              }),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: { "error-input": _vm.$v.form.confirm_password.$error },
                  attrs: { id: "confirm-password-input" }
                },
                [
                  _c("label", [_vm._v(" Confirm Password ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "max-length": 50,
                      "error-message": _vm.confirmErrmessage,
                      type: _vm.confirmPasswordType,
                      placeholder: "Type confirm password"
                    },
                    model: {
                      value: _vm.form.confirm_password,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "confirm_password", $$v)
                      },
                      expression: "form.confirm_password"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { staticClass: "showhide" }, [
                    _c("i", {
                      class: {
                        "fa fa-eye": !_vm.showConfirmPassword,
                        "fa fa-eye-slash": _vm.showConfirmPassword,
                        "eye-error": _vm.$v.form.confirm_password.$error
                      },
                      on: {
                        click: function($event) {
                          _vm.showConfirmPassword = !_vm.showConfirmPassword
                        }
                      }
                    })
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "float-right m__t--20" },
            [
              _c(
                "b-button",
                {
                  staticClass: "btn m__r--5",
                  on: { click: _vm.closeModalchangePassword }
                },
                [_vm._v("\n        Close\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                { staticClass: "btn blue", on: { click: _vm.updatePassword } },
                [_vm._v("\n        Confirm\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "studio-page-content" },
        [
          _vm.tabSelected === "detail" ? _c("j-detail") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "assignment" ? _c("j-assignment") : _vm._e(),
          _vm._v(" "),
          _vm.tabSelected === "log_activity" ? _c("j-log-activity") : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f73e2aa2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f73e2aa2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user-employee/jEmployee.vue
// module id = null
// module chunks = 